import { PostiDesignSystemProvider } from '@postidigital/posti-components'
import { BrandTheme } from '@postidigital/posti-theme'
import React, { PropsWithChildren } from 'react'
import { ThemeProvider } from 'styled-components'

const ThemeWrapper: React.FC<PropsWithChildren> = ({ children }) => (
  <PostiDesignSystemProvider>
    <ThemeProvider theme={BrandTheme}>{children}</ThemeProvider>
  </PostiDesignSystemProvider>
)

export default ThemeWrapper
